"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Git = void 0;
exports.asyncExecute = asyncExecute;
exports.getType = getType;
const child_process_1 = require("child_process");
/**
 * 异步执行命令
 * @param cmd 命令
 * @param dir 运行命令的目录
 * @returns Promise 对象，包含执行状态与输出结果
 */
function asyncExecute(cmd, dir = process.cwd()) {
    const volidateCmdFailed = (status, reason) => {
        if (!status) {
            return {
                status: false,
                data: reason,
            };
        }
    };
    return new Promise(resolve => {
        const cp = (0, child_process_1.spawn)(cmd, {
            cwd: dir,
            stdio: 'pipe',
            shell: true,
        });
        let dataOk = '';
        let dataError = '';
        cp.stdout?.on('data', (data) => {
            dataOk += data.toString().trim();
        });
        cp.stderr?.on('data', (data) => {
            dataError += data.toString().trim();
        });
        cp.on('close', () => {
            let status = true;
            if ((dataOk.length === 0 && dataError.indexOf('error:') > -1) ||
                dataError.indexOf('fatal:') > -1) {
                status = false;
            }
            const data = dataOk.length !== 0 ? dataOk : dataError;
            volidateCmdFailed(status, data);
            resolve({
                status,
                data,
            });
        });
    });
}
/**
 * 获取数据的精确类型
 * @param variable 任意变量
 * @returns 类型字符串
 */
function getType(variable) {
    let temp = Object.prototype.toString.call(variable);
    return temp.substring(8, temp.length - 1);
}
exports.Git = {
    /**
     * 获取当前 Git 分支
     * @param cwd 运行命令的目录
     */
    async getCurrentBranch(cwd = process.cwd()) {
        const { data } = await asyncExecute('git rev-parse --abbrev-ref HEAD', cwd);
        return {
            status: true,
            data,
        };
    },
    /**
     * 获取当前的 Git 标签
     * @param cwd 运行命令的目录
     */
    async getCurrentTag(cwd = process.cwd()) {
        const { data, status } = await asyncExecute('git describe --tags', cwd);
        return {
            status,
            data,
        };
    },
    /**
     * 获取最近一次的提交记录
     * @param cwd 运行命令的目录
     */
    async getLatestCommit(cwd = process.cwd()) {
        const cmd = `git log -1 --pretty=format:'{
        "hash": "%H",
        "author": "%an",
        "email": "%ae",
        "date": "%ad",
        "message": "%s"
      }'`;
        const { data, status } = await asyncExecute(cmd, cwd);
        return {
            status,
            data: JSON.parse(data),
        };
    },
    /**
     * 为当前项目通过 CLI 初始化 Git 用户信息
     * @param name Git 用户名
     * @param email Git 用户邮箱
     * @returns 本地 Git 用户账户信息对象
     */
    async initLocalUser(name, email) {
        let setName = `git config --local user.name "${name}"`;
        let setEmail = `git config --local user.email "${email}"`;
        await asyncExecute(setName);
        await asyncExecute(setEmail);
        const { data } = await asyncExecute('git config --local --list');
        let rows = data.split('\n');
        let local = {};
        rows.forEach(row => {
            let temp = row.split('=');
            if (temp.length >= 2) {
                local[temp[0]] = temp[1];
            }
        });
        return local;
    },
    /**
     * 获取所有的 Git 分支以及当前分支
     * @param cwd 运行命令的目录
     * @returns 所有分支及当前分支的对象
     */
    async getBranchs(cwd = process.cwd()) {
        const cmd = 'git branch';
        let { data } = await asyncExecute(cmd, cwd);
        let branchs = data.split('\n');
        let current = branchs.find(branch => branch.indexOf('*') > -1) || '';
        return {
            current,
            branchs,
        };
    },
    /**
     * 切换 Git 分支
     * @param cwd 运行命令的目录
     * @param branch 分支名称
     */
    async checkout(cwd = process.cwd(), branch) {
        const cmd = `git checkout ${branch}`;
        const expect1 = `Your branch is up to date with 'origin/${branch}'.`;
        const expect2 = `Your branch is ahead of 'origin/${branch}'`;
        const expect3 = `Switched to a new branch '${branch}'`;
        const { data } = await asyncExecute(cmd, cwd);
        let realStatus = false;
        if (data.indexOf(expect1) >= 0 || data.indexOf(expect2) >= 0 || data.indexOf(expect3) >= 0) {
            realStatus = true;
        }
        return {
            status: realStatus,
            data,
        };
    },
    /**
     * 获取当前分支的状态
     * @param cwd 运行命令的目录
     * @returns 当前分支状态的字符串内容
     */
    async status(cwd = process.cwd()) {
        let cmd = 'git status';
        const { data } = await asyncExecute(cmd, cwd);
        let status = true;
        if (data.indexOf('use "git add" and/or "git commit -a"') > -1) {
            status = false;
        }
        return {
            status,
            data,
        };
    },
    /**
     * 在当前分支提交所有更改
     * @param cwd 运行命令的目录
     * @param msg 提交说明信息
     * @returns 提交分支状态的布尔值
     */
    async commit(cwd = process.cwd(), msg) {
        const comitCmd = `git commit -m "${msg}"`;
        const expect1 = 'use "git push"';
        const expect2 = 'nothing to commit';
        const expect3 = 'changed';
        const expect4 = 'insertions';
        const expect5 = 'deletions';
        await asyncExecute('git add .', cwd);
        const { data } = await asyncExecute(comitCmd, cwd);
        let realStatus = false;
        if (data.indexOf(expect1) >= 0 ||
            data.indexOf(expect2) >= 0 ||
            data.indexOf(expect3) >= 0 ||
            data.indexOf(expect4) >= 0 ||
            data.indexOf(expect5) >= 0) {
            realStatus = true;
        }
        return {
            status: realStatus,
            data,
        };
    },
    /**
     * 拉取分支代码
     * @param cwd 运行命令的目录
     */
    async pull(cwd = process.cwd()) {
        const cmd = 'git pull';
        const expect1 = 'Already up to date.';
        let current = await exports.Git.status(cwd);
        if (!current.status) {
            return {
                status: current.status,
                data: current.data,
            };
        }
        const { data } = await asyncExecute(cmd, cwd);
        let realStatus = data.indexOf(expect1) >= 0 ? true : false;
        return {
            status: realStatus,
            data,
        };
    },
    /**
     * 推送分支代码
     * @param cwd 运行命令的目录
     * @param isFource 是否强制推送
     */
    async push(cwd = process.cwd(), isFource = false) {
        let cmd = 'git push';
        if (isFource)
            cmd = 'git push -f';
        let current = await exports.Git.status(cwd);
        if (!current.status) {
            return {
                status: current.status,
                data: current.data,
            };
        }
        const { status, data } = await asyncExecute(cmd, cwd);
        return {
            status,
            data,
        };
    },
    /**
     * 合并分支
     * @param cwd 运行命令的目录
     * @param branch 要合并的分支名
     */
    async merge(cwd = process.cwd(), branch) {
        const cmd = `git merge ${branch}`;
        const expect1 = `Merge made by the 'recursive' strategy`;
        const expect2 = `Already up to date`;
        const expect3 = `not something we can merge`;
        let current = await exports.Git.status(cwd);
        if (!current.status) {
            return {
                status: current.status,
                data: current.data,
            };
        }
        const { data } = await asyncExecute(cmd, cwd);
        let realStatus = false;
        if (data.indexOf(expect1) >= 0 || data.indexOf(expect2) >= 0 || data.indexOf(expect3) >= 0) {
            realStatus = true;
        }
        return {
            status: realStatus,
            data,
        };
    },
    /**
     * 更新子模块
     * @param cwd 运行命令的目录
     */
    async updateSubmodule(cwd = process.cwd()) {
        const cmd = 'git submodule update --remote';
        const { data, status } = await asyncExecute(cmd, cwd);
        return {
            status: status,
            data: data,
        };
    },
    /**
     * 获取远程分支
     * @param cwd 运行命令的目录
     * @param branch 分支名称
     */
    async fetchOrigin(cwd = process.cwd(), branch) {
        const cmd = 'git fetch origin' + ' ' + branch;
        const { status, data } = await asyncExecute(cmd, cwd);
        return {
            status,
            data,
        };
    },
    /**
     * 变基操作
     * @param cwd 运行命令的目录
     * @param branch 分支名称
     */
    async rebaese(cwd = process.cwd(), branch) {
        const cmd = 'git rebase origin/' + branch;
        const { status, data } = await asyncExecute(cmd, cwd);
        return {
            status,
            data,
        };
    },
    /**
     * 删除分支
     * @param cwd 运行命令的目录
     * @param branch 分支名称
     */
    async deleteBranch(cwd = process.cwd(), branch) {
        const cmd = `git branch -D ${branch}`;
        const { data } = await asyncExecute(cmd, cwd);
        return {
            status: true,
            data: data,
        };
    },
};
exports.default = {
    Git: exports.Git,
    asyncExecute,
};
